query GetGeometryTypeBimClass(
    $id: ID!
) {
    geometryType(
        id: $id
        resolution: ["public", "latest"]
    ) {
        id

        bimClass(
            resolution: ["public", "latest"]
        ) {
            id

            revisionID
        }
    }
}
